import { RootState } from "@/shared/types";
import { IAuthParams } from "./types/interfaces";

export const selectAuthParams = (state: RootState): IAuthParams =>
  state.auth.params;
